import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore, type PersistConfig } from 'redux-persist'
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'redux-persist/es/constants'
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/es/storage/session'
import type { UnknownAction } from 'redux'
import notificationSlice from '@/store/notificationSlice'
import themeConfigSlice from '@/store/themeConfigSlice'

//const history = createBrowserHistory()

const createRootReducer = () =>
  combineReducers({
    themeConfig: themeConfigSlice,
    notification: notificationSlice,
  })

type RootReducer = ReturnType<typeof createRootReducer>
type RootState = ReturnType<RootReducer>

const persistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: ['notification', 'themeConfig', 'chart'],
  stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
}

let rehydrationComplete!: () => void
// let rehydrationFailed

const rehydrationPromise = new Promise<void>((resolve) => {
  rehydrationComplete = resolve
  // rehydrationFailed = reject
})
export function rehydration() {
  return rehydrationPromise
}

const resetEnhancer =
  (rootReducer: RootReducer) => (state: RootState | undefined, action: UnknownAction) => {
    if (action.type !== 'LOGOUT_SUCCESS') return rootReducer(state, action)

    return rootReducer(undefined, { type: '@@INIT' })
  }

const persistedReducer = persistReducer<RootState, UnknownAction>(
  persistConfig,
  resetEnhancer(createRootReducer()),
)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredActionPaths: ['payload.content'],
      },
    }),
})

const persistor = persistStore(store, null, () => {
  // this will be invoked after rehydration is complete
  rehydrationComplete()
})

export { persistor, store }
export type IRootState = ReturnType<typeof store.getState>
